var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.666 30.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M197.615,368.616a18.52,18.52,0,0,1,1.429-1.832c4.022-4.037,8.075-8.045,12.107-12.072a2.535,2.535,0,0,1,2.584-.812,2.476,2.476,0,0,1,1.087,4.2c-1.49,1.528-3.021,3.017-4.534,4.522q-1.829,1.82-3.657,3.64c-.126.125-.242.261-.454.492h32.438a2.489,2.489,0,0,1,.375,4.964c-.227.012-.456,0-.684,0H206.165c.264.276.426.453.6.622,2.673,2.661,5.357,5.311,8.016,7.986a2.5,2.5,0,1,1-3.58,3.475q-3.716-3.713-7.449-7.41c-1.572-1.564-3.161-3.112-4.7-4.7a20.724,20.724,0,0,1-1.43-1.832Z",
    transform: "translate(-197.615 -353.808)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c4fd38ae.svg";
export { ForwardRef as ReactComponent };